(function () {
  'use strict';

  var configEl = document.getElementById('lux-integrations-config');
  if (!configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    return;
  }

  var STOREFRONT_MUTATION = [
    'mutation customerCreate($input: CustomerCreateInput!) {',
    '  customerCreate(input: $input) {',
    '    customer { id email }',
    '    customerUserErrors { code field message }',
    '  }',
    '}'
  ].join('\n');

  function storefrontGraphql(query, variables) {
    var token = config.storefrontToken;
    if (!token) return Promise.reject(new Error('missing_token'));

    return fetch('/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (res) {
      return res.json();
    });
  }

  function subscribeViaGraphql(payload) {
    return storefrontGraphql(STOREFRONT_MUTATION, {
      input: {
        email: payload.email,
        firstName: payload.firstName || undefined,
        lastName: payload.lastName || undefined,
        acceptsMarketing: true
      }
    });
  }

  function subscribeViaForm(form) {
    var fd = new FormData(form);
    return fetch(form.action || '/contact', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    });
  }

  function showMessage(form, text, isError) {
    var msg = form.querySelector('[data-lux-nl-message]');
    if (!msg) {
      msg = document.createElement('p');
      msg.setAttribute('data-lux-nl-message', '');
      msg.className = 'nl-disc';
      form.appendChild(msg);
    }
    msg.textContent = text;
    msg.style.color = isError ? '#ffb4b4' : 'rgba(255,255,255,0.75)';
  }

  document.querySelectorAll('[data-lux-newsletter-form]').forEach(function (wrap) {
    var form = wrap.tagName === 'FORM' ? wrap : wrap.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      if (!config.useGraphql) return;

      event.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var firstInput = form.querySelector('input[name="contact[first_name]"]');
      var lastInput = form.querySelector('input[name="contact[last_name]"]');
      var btn = form.querySelector('button[type="submit"]');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      var label = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Joining…';
      }

      var payload = {
        email: email,
        firstName: firstInput ? firstInput.value.trim() : '',
        lastName: lastInput ? lastInput.value.trim() : ''
      };

      subscribeViaGraphql(payload)
        .then(function (result) {
          var errors = result && result.data && result.data.customerCreate && result.data.customerCreate.customerUserErrors;
          if (errors && errors.length) {
            var already = errors.some(function (e) {
              return e.code === 'TAKEN' || (e.message && e.message.toLowerCase().indexOf('taken') !== -1);
            });
            if (already) {
              showMessage(form, 'You\'re already on the list — thank you!', false);
              return;
            }
            return subscribeViaForm(form).then(function () {
              showMessage(form, config.successMessage || 'Welcome to the Luxlaria community!', false);
            });
          }
          showMessage(form, config.successMessage || 'Welcome to the Luxlaria community!', false);
          if (emailInput) emailInput.value = '';
          if (firstInput) firstInput.value = '';
          if (lastInput) lastInput.value = '';
        })
        .catch(function () {
          subscribeViaForm(form)
            .then(function () {
              showMessage(form, config.successMessage || 'Welcome to the Luxlaria community!', false);
            })
            .catch(function () {
              showMessage(form, 'Something went wrong. Please try again.', true);
            });
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = label;
          }
        });
    });
  });

  /* Fallback chat launcher when Shopify Inbox embed is not active */
  if (config.showChatFallback && !document.querySelector('[data-shopify-inbox], #ShopifyChat, shopify-chat')) {
    var chat = document.createElement('a');
    chat.href = config.chatFallbackUrl || '/pages/contact';
    chat.className = 'lux-chat-fallback';
    chat.setAttribute('aria-label', 'Chat with Luxlaria');
    chat.innerHTML = '<span aria-hidden="true">💬</span>';
    document.body.appendChild(chat);
  }
})();
